import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Alert.css';

interface IAlertProps {
  isVisible: boolean;
  message: string;
  onClose(): void;
  onCancel?: () => void;
}

export const Alert: React.VFC<IAlertProps> = ({ isVisible, message, onClose, onCancel }) => {
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timeout: any;
    if (isVisible) {
      timeout = setTimeout(onClose, 4000);
    }

    return () => clearTimeout(timeout);
  }, [isVisible, onClose]);

  return (
    <div className={classNames(styles['alert'], isVisible && styles['visible'])}>
      {message}
      {onCancel && (
        <>
          &nbsp;
          <button className={styles['button']} type="button" onClick={onCancel}>
            Отменить
          </button>
        </>
      )}
    </div>
  );
};
